import { apiClient } from './api';
import type { GetTeamsResponse, GetAllTeamsApiRequest } from '@momentum/types';

export const teamsService = {
  // Get all teams
  async getAllTeams(params?: GetAllTeamsApiRequest): Promise<GetTeamsResponse> {
    const queryParams = new URLSearchParams();

    if (params?.isDeleted !== undefined) {
      queryParams.append('isDeleted', params.isDeleted.toString());
    }

    const queryString = queryParams.toString();
    const url = queryString ? `/teams?${queryString}` : '/teams';

    return (await apiClient.get(url)).data;
  },

  // Get all teams for onboarding (uses anonymous session)
  async getAllTeamsForOnboarding(
    params?: GetAllTeamsApiRequest
  ): Promise<GetTeamsResponse> {
    const url = new URL('/teams/onboarding', window.location.origin);

    if (params?.isDeleted !== undefined) {
      url.searchParams.append('isDeleted', params.isDeleted.toString());
    }

    return (await apiClient.get(url.pathname + url.search)).data;
  },
};
